import { type MantineColor } from '@mantine/core';
import { TraderStatus, WorkStrategy } from './model';
import { WorkingStatus } from './model/working-status';

type TraderStatusMeta = Record<
    TraderStatus,
    {
        color: MantineColor;
        label: string;
    }
>;

export const traderStatusMeta = {
    [TraderStatus.STATUS_UNSPECIFIED]: {
        color: 'gray.5',
        label: 'Не определён',
    },
    [TraderStatus.STATUS_CREATED]: {
        color: 'blue.5',
        label: 'Создан',
    },
    [TraderStatus.STATUS_ACTIVE]: {
        color: 'green.6',
        label: 'Активен',
    },
    [TraderStatus.STATUS_BLOCKED]: {
        color: 'red.6',
        label: 'Заблокирован',
    },
} as const satisfies TraderStatusMeta;

export const traderStatusColors: Record<TraderStatus, MantineColor> = {
    [TraderStatus.STATUS_UNSPECIFIED]: traderStatusMeta[TraderStatus.STATUS_UNSPECIFIED].color,
    [TraderStatus.STATUS_CREATED]: traderStatusMeta[TraderStatus.STATUS_CREATED].color,
    [TraderStatus.STATUS_ACTIVE]: traderStatusMeta[TraderStatus.STATUS_ACTIVE].color,
    [TraderStatus.STATUS_BLOCKED]: traderStatusMeta[TraderStatus.STATUS_BLOCKED].color,
} as const;

export const traderStatuses = [
    {
        value: TraderStatus.STATUS_CREATED,
        label: traderStatusMeta[TraderStatus.STATUS_CREATED].label,
    },
    {
        value: TraderStatus.STATUS_ACTIVE,
        label: traderStatusMeta[TraderStatus.STATUS_ACTIVE].label,
    },
    {
        value: TraderStatus.STATUS_BLOCKED,
        label: traderStatusMeta[TraderStatus.STATUS_BLOCKED].label,
    },
] as const;

type WorkingStatusMeta = Record<
    WorkingStatus,
    {
        color: MantineColor;
        label: string;
    }
>;

export const workingStatusMeta = {
    [WorkingStatus.WORKING_STATUS_UNSPECIFIED]: {
        color: 'gray.5',
        label: 'Не определён',
    },
    [WorkingStatus.WORKING_STATUS_READY]: {
        color: 'green.6',
        label: 'Готов',
    },
    [WorkingStatus.WORKING_STATUS_NOT_READY]: {
        color: 'yellow.6',
        label: 'Не готов',
    },
    [WorkingStatus.WORKING_STATUS_IN_WORK]: {
        color: 'blue.5',
        label: 'В работе',
    },
} as const satisfies WorkingStatusMeta;

export const workingStatusColors: Record<WorkingStatus, MantineColor> = {
    [WorkingStatus.WORKING_STATUS_UNSPECIFIED]: workingStatusMeta[WorkingStatus.WORKING_STATUS_UNSPECIFIED].color,
    [WorkingStatus.WORKING_STATUS_READY]: workingStatusMeta[WorkingStatus.WORKING_STATUS_READY].color,
    [WorkingStatus.WORKING_STATUS_NOT_READY]: workingStatusMeta[WorkingStatus.WORKING_STATUS_NOT_READY].color,
    [WorkingStatus.WORKING_STATUS_IN_WORK]: workingStatusMeta[WorkingStatus.WORKING_STATUS_IN_WORK].color,
} as const;

export const workingStatuses = [
    {
        value: WorkingStatus.WORKING_STATUS_READY,
        label: workingStatusMeta[WorkingStatus.WORKING_STATUS_READY].label,
    },
    {
        value: WorkingStatus.WORKING_STATUS_NOT_READY,
        label: workingStatusMeta[WorkingStatus.WORKING_STATUS_NOT_READY].label,
    },
    {
        value: WorkingStatus.WORKING_STATUS_IN_WORK,
        label: workingStatusMeta[WorkingStatus.WORKING_STATUS_IN_WORK].label,
    },
] as const;

type WorkStrategyMeta = Record<
    WorkStrategy,
    {
        color: MantineColor;
        label: string;
    }
>;

export const workStrategyMeta = {
    [WorkStrategy.TRADER_WORK_STRATEGY_UNSPECIFIED]: {
        color: 'gray.5',
        label: 'Не определена',
    },
    [WorkStrategy.TRADER_WORK_STRATEGY_TRANSACTION_SPLITTING]: {
        color: 'violet.6',
        label: 'Разделение транзакций',
    },
    [WorkStrategy.TRADER_WORK_STRATEGY_P2P_PLATFORM]: {
        color: 'teal.6',
        label: 'P2P-платформа',
    },
} as const satisfies WorkStrategyMeta;

export const workStrategyColors: Record<WorkStrategy, MantineColor> = {
    [WorkStrategy.TRADER_WORK_STRATEGY_UNSPECIFIED]:
        workStrategyMeta[WorkStrategy.TRADER_WORK_STRATEGY_UNSPECIFIED].color,
    [WorkStrategy.TRADER_WORK_STRATEGY_TRANSACTION_SPLITTING]:
        workStrategyMeta[WorkStrategy.TRADER_WORK_STRATEGY_TRANSACTION_SPLITTING].color,
    [WorkStrategy.TRADER_WORK_STRATEGY_P2P_PLATFORM]:
        workStrategyMeta[WorkStrategy.TRADER_WORK_STRATEGY_P2P_PLATFORM].color,
} as const;

export const workStrategies = [
    {
        value: WorkStrategy.TRADER_WORK_STRATEGY_TRANSACTION_SPLITTING,
        label: workStrategyMeta[WorkStrategy.TRADER_WORK_STRATEGY_TRANSACTION_SPLITTING].label,
    },
    {
        value: WorkStrategy.TRADER_WORK_STRATEGY_P2P_PLATFORM,
        label: workStrategyMeta[WorkStrategy.TRADER_WORK_STRATEGY_P2P_PLATFORM].label,
    },
] as const;
